export const FeatureFlags = {
  enablePortfolioSummary: false,
  enableNextGenDashboard: true,
  enableCompliancePortfolioDashboard: true,
  enableServiceProviderScreeningPilot: true,
  enableCarbonClear: false,
  enableComplianceNav: false,
  enableExploreNav: false,
  enableScreeningNav: false,
  enableBulkPropertyAdd: false,
  enableExploreResourcesSidebar: false,
  enableIncentiveDbDiagnostics: false,
};
